import { createStore as x, is as N, combine as R, createEffect as k, attach as T, sample as c, createEvent as _, createNode as Pe, step as ut, split as J, withRegion as ft, merge as se, scopeBind as Se, createApi as dt } from "effector";
const re = {
  isData: (e) => !0,
  getErrorMessages: () => []
};
function D({
  field: e
}) {
  let t;
  if (e === void 0)
    t = x((r) => null, {
      serialize: "ignore",
      name: "ff.$target/undefined",
      sid: "ff.$target/undefined"
    });
  else if (N.store(e))
    t = R(
      e,
      (n) => (a) => n ?? null
    );
  else if (e != null && e.source && (e != null && e.fn)) {
    const r = e;
    t = R(
      r.source,
      (n) => (a) => r.fn(a, n) ?? null
    );
  } else if (typeof e == "function") {
    const r = e;
    t = x(
      (n) => r(n) ?? null,
      {
        serialize: "ignore",
        name: "ff.$target/callbackField",
        sid: "ff.$target/$callbackField"
      }
    );
  } else {
    const r = e;
    t = x((n) => r ?? null, {
      serialize: "ignore",
      name: "ff.$target/valueField",
      sid: "ff.$target/$valueField"
    });
  }
  return t;
}
function pt(e) {
  let t;
  if (e === void 0)
    t = k(async (r) => null);
  else if (N.store(e))
    t = T({
      source: e,
      async effect(n, a) {
        return n;
      }
    });
  else if (e.source && e.fn) {
    const r = e;
    t = T({
      source: r.source,
      async effect(n, a) {
        return r.fn(a, n);
      }
    });
  } else if (typeof e == "function") {
    const r = e;
    t = k(async (n) => r(n));
  } else {
    const r = e;
    t = k(async (n) => r);
  }
  return t;
}
function O(e) {
  return e ? N.store(e) ? e : x(e, {
    serialize: "ignore",
    name: "ff.$target/valueField",
    sid: "ff.$target/$valueField"
  }) : x(null, {
    serialize: "ignore",
    name: "ff.$target/undefined",
    sid: "ff.$target/$undefined"
  });
}
function mt(e) {
  return N.store(e) ? e : e != null && e.source ? e.source : null;
}
function Ar(e, t) {
  const r = {}, n = {};
  for (const [o, s] of Object.entries(e))
    N.store(s) ? r[o] = s : s != null && s.source && (s != null && s.fn) ? (r[o] = s.source, n[o] = s.fn) : typeof s == "function" ? n[o] = s : r[o] = s;
  return {
    source: R(r),
    fn: (o, s) => {
      const i = {};
      for (const l of Object.keys(e))
        l in s && (i[l] = s[l]), l in n && (i[l] = n[l](o, s[l]));
      return t ? t(i) : i;
    }
  };
}
function Fe({
  clock: e,
  timeout: t,
  target: r = _()
}) {
  const n = k(
    ({ payload: a, milliseconds: o }) => new Promise((s) => {
      setTimeout(s, o, a);
    })
  );
  return c({
    source: O(t),
    clock: e,
    fn: (a, o) => ({
      payload: o,
      milliseconds: a
    }),
    target: n
  }), c({
    clock: n.doneData,
    target: r
  }), r;
}
function ce(e, t) {
  let r = [], n = () => !1;
  Array.isArray(e) ? (r = e, n = t) : Array.isArray(e.stores) && (r = e.stores, n = e.predicate);
  let a;
  ht(n) ? a = n : N.store(n) ? a = n.map((i) => (l) => i === l) : a = (i) => i === n;
  const o = R(r);
  return R(a, o, (i, l) => l.every(i));
}
function ht(e) {
  return typeof e == "function";
}
function B(e) {
  return e.map((t) => !t);
}
function Ie(...e) {
  return ce({ predicate: !0, stores: e });
}
function Te({
  clock: e,
  until: t
}) {
  const r = _(), n = x(!1, {
    serialize: "ignore",
    name: "ff.$fired",
    sid: "ff.$fired"
  }).on(r, () => !0).on(e, () => !1);
  return c({
    clock: [e, t],
    source: e,
    filter: Ie(t, B(n)),
    target: r
  }), r;
}
function ne(e) {
  if (e === "ignore")
    return "ignore";
}
const $e = k(() => Date.now());
function yt({
  clock: e
}) {
  const t = x(Date.now(), {
    name: "ff.$time",
    sid: "ff.$time"
  });
  return c({
    clock: e,
    fn: () => {
    },
    target: $e
  }), c({ clock: $e.doneData, target: t }), t;
}
function E(e) {
  return e.map((t) => t, { skipVoid: !1 });
}
function gt(e) {
  const t = _(), r = x(null, {
    serialize: "ignore",
    name: "ff.$timeoutId",
    sid: "ff.$timeoutId"
  }).on(t, (y, u) => u), n = _(), a = x(null, {
    serialize: "ignore",
    name: "ff.$rejecter",
    sid: "ff.$rejecter"
  }).on(n, (y, u) => u), o = _(), s = T({
    source: {
      timeoutId: r,
      rejectPromise: a
    },
    effect: ({ timeoutId: y, rejectPromise: u }) => (y && clearTimeout(y), u && u(), new Promise(($, f) => {
      n(f), t(setTimeout($, 0));
    }))
  });
  a.reset(s.done), r.reset(s.done);
  const i = x([], {
    serialize: "ignore",
    name: "ff.$payload",
    sid: "ff.$payload"
  }).on(e, (y, u) => [u]), l = x(!0, {
    serialize: "ignore",
    sid: "ff.$canTick",
    name: "ff.$canTick"
  }), g = _();
  return l.on(g, () => !1).on(
    [
      o,
      // debounce timeout can be restarted in later ticks
      s
    ],
    () => !0
  ), c({
    clock: e,
    filter: l,
    target: g
  }), c({
    clock: g,
    target: s
  }), c({
    source: i,
    clock: s.done,
    fn: ([y]) => y,
    target: o
  }), o;
}
function _e(e, t) {
  const r = Object.entries(e).map(
    ([n, a]) => [n, t(a)]
  );
  return Object.fromEntries(r);
}
function ke(e) {
  const t = {};
  for (const [r, n] of Object.entries(e))
    for (const [a, o] of Object.entries(n))
      t[a] = { ...t[a], [r]: o };
  return t;
}
function $t({ min: e, max: t }) {
  return Math.random() * (t - e) + e;
}
function _t() {
  const e = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    resolve: () => {
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    reject: () => {
    },
    // @ts-expect-error it will be set later
    promise: null
  };
  return e.promise = new Promise((t, r) => {
    e.resolve = t, e.reject = r;
  }), e.promise.catch(() => {
  }), e;
}
function kt(e) {
  return e == null;
}
function ve(e) {
  return !kt(e);
}
function Z(e, t) {
  try {
    if (e === t || Number.isNaN(e) && Number.isNaN(t))
      return !0;
    const r = be(e), n = be(t);
    if (r !== n)
      return !1;
    if (r === "pure-object") {
      if (e === t)
        return !0;
      const a = Object.keys(e), o = Object.keys(t).length;
      if (a.length !== o)
        return !1;
      for (let s = 0, i = a.length; s < i; s++) {
        const l = a[s];
        if (!Object.prototype.hasOwnProperty.call(t, a[s]))
          return !1;
        const g = e[l], y = t[l];
        if (g === e || y === t || g === t || y === e)
          return g === y;
        if (!Z(g, y))
          return !1;
      }
      return !0;
    } else if (r === "array") {
      if (e.length === t.length)
        for (let a = 0; a < e.length; a++) {
          const o = e[a], s = t[a];
          if (o === e || s === t || o === t || s === e)
            return o === s;
          if (!Z(o, s))
            return !1;
        }
      else
        return !1;
      return !0;
    } else if (r === "object" && e.valueOf && t.valueOf)
      return e.valueOf() === t.valueOf();
  } catch {
  }
  return !1;
}
function vt(e) {
  if (Array.isArray(e))
    return !0;
  const t = e.length;
  return typeof t == "number" && t > -1 ? t ? 0 in e && t - 1 in e : !0 : !1;
}
function be(e) {
  const t = typeof e;
  return t === "object" ? e === null ? "null" : vt(e) ? "array" : e.constructor === Object || Object.getPrototypeOf(e) === null ? "pure-object" : "object" : t;
}
function bt(e, t) {
  const r = [], n = [];
  for (const a of e)
    t(a) ? r.push(a) : n.push(a);
  return [r, n];
}
function Q(e) {
  return (t) => t[e];
}
function wt(e) {
  return Array.from(new Set(e));
}
class At {
  constructor(t = !1) {
    this._resolve = null, this._promise = Promise.resolve(), t && this.acquire();
  }
  get isLocked() {
    return !!this._resolve;
  }
  acquire() {
    this.isLocked || (this._promise = new Promise((t) => {
      this._resolve = t;
    }));
  }
  waitForUnlock() {
    return this._promise;
  }
  release() {
    this._resolve && (this._resolve(), this._resolve = null);
  }
}
function xt({
  events: e,
  reset: t
}) {
  const r = _(), n = x([], { serialize: "ignore" });
  return t && c({ clock: t, target: n.reinit }), e.forEach((a, o) => {
    n.on(a, (s) => wt([...s, o]));
  }), c({
    clock: e,
    source: n,
    filter: (a) => a.length === e.length,
    target: r
  }), r;
}
function De() {
  var e, t;
  return ((t = (e = Pe({ regional: !0 }).family.owners[0]) == null ? void 0 : e.meta) == null ? void 0 : t.name) ?? void 0;
}
const je = "INVALID_DATA", Oe = "TIMEOUT", Re = "ABORT", Ne = "PREPARATION", qe = "HTTP", Le = "NETWORK", Et = "CONFIGURATION";
function ee(e) {
  return {
    ...e,
    errorType: je,
    explanation: "Response was considered as invalid against a given contract"
  };
}
function Pt(e) {
  return {
    ...e,
    errorType: Oe,
    explanation: "Request was cancelled due to timeout"
  };
}
function ze() {
  return {
    errorType: Re,
    explanation: "Request was cancelled due to concurrency policy"
  };
}
function St(e) {
  return {
    ...e,
    errorType: Ne,
    explanation: "Extraction of data from the response was failed"
  };
}
function Ce(e) {
  return {
    ...e,
    errorType: qe,
    explanation: "Request was finished with unsuccessful HTTP code"
  };
}
function Ft(e) {
  return {
    ...e,
    errorType: Le,
    explanation: "Request was failed due to network problems"
  };
}
function oe(e) {
  return {
    ...e,
    errorType: Et,
    explanation: "Operation is misconfigured"
  };
}
function It(e) {
  return k({
    handler: ({ result: r }) => {
      if (!e.isData(r))
        throw ee({
          validationErrors: e.getErrorMessages(r),
          response: r
        });
      return r;
    },
    sid: "ff.applyContractFx"
  });
}
function Tt(e) {
  return !!(e === !0 || Array.isArray(e) && e.length === 0 || typeof e == "string" && e.length === 0);
}
function we(e) {
  return e === !0 ? [] : e === !1 ? ["Invalid data"] : Array.isArray(e) ? e.length === 0 ? [] : e : [e];
}
const Dt = () => !0;
function xr(e) {
  var t;
  return ((t = e.error) == null ? void 0 : t.errorType) === je;
}
function Er(e) {
  var t;
  return ((t = e.error) == null ? void 0 : t.errorType) === Oe;
}
function jt(e) {
  var t;
  return ((t = e.error) == null ? void 0 : t.errorType) === Re;
}
function Pr(e) {
  var t;
  return ((t = e.error) == null ? void 0 : t.errorType) === Ne;
}
function Me(e) {
  var t;
  return ((t = e.error) == null ? void 0 : t.errorType) === qe;
}
function Sr(e) {
  return function(r) {
    return Me(r) ? (Array.isArray(e) ? e : [e]).includes(r.error.status) : !1;
  };
}
function Fr(e) {
  var t;
  return ((t = e.error) == null ? void 0 : t.errorType) === Le;
}
let te = null, ie = !1;
function Ot() {
  ie = !0;
}
function Rt() {
  ie = !1;
}
function Be(e) {
  if (!ie)
    throw oe({
      reason: "onAbort call is not allowed",
      validationErrors: [
        "onAbort can be called only in the context of a handler before any async operation is performed"
      ]
    });
  if (te)
    throw oe({
      reason: "onAbort call is not allowed",
      validationErrors: ["onAbort can be called only once per operation"]
    });
  te = e;
}
function Nt() {
  const e = te;
  return te = null, e;
}
function qt(e) {
  const t = _(e.shortName + ".internalCall"), r = ut.compute({
    fn: (a) => {
      const o = a.handler, s = Lt(o, t);
      return a.handler = s, a;
    }
  });
  return zt(e).seq.splice(1, 0, r), t;
}
function Lt(e, t) {
  function r(...n) {
    const { result: a, abortCallback: o } = Bt(e, ...n);
    if (a instanceof Promise) {
      const s = _t(), i = Ae(s, o);
      return t(i), a.then(s.resolve, s.reject), s.promise;
    } else {
      const s = Ae(void 0, o);
      return t(s), a;
    }
  }
  return r;
}
function Ae(e, t) {
  let r = e ? "pending" : "finished";
  function n() {
    r = "finished", a.status = r;
  }
  e && e.promise.then(n, n);
  const a = {
    id: Mt(),
    status: r,
    abort: (o = ze()) => {
      t == null || t(), r !== "finished" && e && e.reject(o);
    },
    promise: e == null ? void 0 : e.promise
  };
  return a;
}
function zt(e) {
  return e.graphite.scope.runner;
}
let Ct = 0;
function Mt() {
  return `${Ct++}`;
}
function Bt(e, ...t) {
  Ut(), Ot();
  const r = e(...t), n = Nt();
  return Rt(), {
    result: r,
    abortCallback: n
  };
}
const Ut = _();
function Ue(e, {
  strategy: t,
  abortAll: r
}) {
  e.__.meta.flags.concurrencyFieldUsed && console.error(
    `Both concurrency-operator and concurrency-field are used on operation ${e.__.meta.name}.`,
    "Please use only concurrency-operator, because field concurrency-field in createJsonQuery and createJsonMutation is deprecated and will be deleted soon."
  ), e.__.meta.flags.concurrencyOperatorUsed = !0;
  const n = Ve(e);
  if (t)
    switch (t) {
      case "TAKE_EVERY":
        break;
      case "TAKE_FIRST": {
        const a = x(!1, { serialize: "ignore" }), o = _();
        c({
          clock: o,
          fn: () => !0,
          target: a
        });
        const s = {
          name: "concurrency",
          get: T({
            source: a,
            async effect(i, l) {
              if (i)
                throw ze();
              return o(), null;
            }
          })
        };
        e.__.lowLevelAPI.dataSources.unshift(s), c({
          clock: e.finished.finally,
          fn: () => !1,
          target: a
        });
        break;
      }
      case "TAKE_LATEST": {
        c({
          clock: e.__.lowLevelAPI.callObjectCreated,
          source: n,
          fn: (a, o) => a.filter((s) => s !== o),
          target: le
        });
        break;
      }
    }
  return r && He(e, { clock: r }), e;
}
function He(e, { clock: t }) {
  c({ clock: t, source: Ve(e), target: le });
}
function Ve(e) {
  if (!e.__.meta.$callObjects) {
    const t = x([], { serialize: "ignore" });
    c({
      clock: e.__.lowLevelAPI.callObjectCreated,
      source: t,
      fn: (r, n) => r.filter((a) => a.status === "pending").concat(n),
      target: t
    }), c({
      clock: le.done,
      source: t,
      fn: (r, { params: n }) => r.filter((a) => !n.includes(a)),
      target: t
    }), e.__.meta.$callObjects = t;
  }
  return e.__.meta.$callObjects;
}
const le = k(
  (e) => e.forEach((t) => t.abort())
);
function Ke({
  name: e,
  meta: t,
  kind: r,
  serialize: n,
  enabled: a,
  contract: o,
  validate: s,
  mapData: i,
  sourced: l,
  paramsAreMeaningless: g
}) {
  const y = _(), u = _(), $ = _(), f = _(), d = It(
    o
  ), m = e ?? "unnamed", h = k({
    handler: () => {
      throw new Error("Not implemented");
    },
    sid: `ff.${m}.executeFx`,
    name: `${m}.executeFx`
  }), w = qt(h), F = [{
    name: "remote_source",
    get: k(async ({ params: p }) => ({ result: await h(p), stale: !1 }))
  }], {
    retrieveDataFx: I,
    notifyAboutNewValidDataFx: q,
    notifyAboutDataInvalidationFx: C
  } = Ht(F), M = _(), v = _(), S = _();
  c({
    clock: M,
    fn: (p) => ({
      params: p,
      meta: { stopErrorPropagation: !1, stale: !0 }
    }),
    target: f
  });
  const A = {
    success: _(),
    failure: _(),
    skip: _(),
    finally: _()
  }, z = _(), U = _(), H = _();
  J({
    source: z,
    match: {
      aborted: ({ error: p }) => jt({ error: p })
    },
    cases: {
      aborted: H,
      __: A.failure
    }
  });
  const L = x("initial", {
    sid: `ff.${m}.$status`,
    name: `ff.${m}.$status`,
    serialize: n
  });
  c({ clock: v, target: L.reinit });
  const G = x([], {
    serialize: "ignore",
    name: `ff.${m}.$statusHistory`,
    sid: `ff.${m}.$statusHistory`
  });
  c({
    clock: L.updates,
    source: G,
    fn: (p, b) => [...p, b],
    target: G
  });
  const V = O(a ?? !0).map(Boolean), me = x(void 0, {
    serialize: "ignore",
    name: `ff.${m}.$latestParams`,
    sid: `ff.${m}.$latestParams`,
    skipVoid: !1
  }), st = L.map((p) => p === "initial"), ot = L.map((p) => p === "pending"), ct = L.map((p) => p === "fail"), it = L.map((p) => p === "done"), lt = L.map((p) => ["fail", "done"].includes(p));
  c({
    clock: [
      I.map(() => "pending"),
      A.success.map(() => "done"),
      A.failure.map(() => "fail"),
      c({
        clock: H,
        source: {
          history: G,
          retrieveDataPengind: I.pending
        },
        fn: ({ history: p, retrieveDataPengind: b }) => b ? "pending" : p[p.length - 2] ?? "initial"
      })
    ],
    target: L
  }), c({
    clock: f,
    filter: V,
    fn: ({ params: p }) => p,
    target: me
  }), c({
    clock: M,
    filter: B(V),
    fn(p) {
      return {
        params: p,
        meta: { stopErrorPropagation: !1, stale: !1 }
      };
    },
    target: A.skip
  }), c({
    clock: y,
    fn: ({ params: p }) => ({
      params: p,
      meta: { stopErrorPropagation: !1, stale: !0 }
    }),
    target: C
  }), c({
    clock: C.finally,
    source: y,
    filter: ({ refresh: p }) => p,
    fn: ({ params: p }) => ({
      params: p,
      meta: { stopErrorPropagation: !1, stale: !0 }
    }),
    target: f
  }), c({
    clock: f,
    filter: V,
    target: I
  }), c({ clock: I, target: S }), c({
    clock: I.done,
    fn: ({ params: p, result: b }) => ({
      params: p.params,
      result: b.result,
      meta: {
        stopErrorPropagation: b.stopErrorPropagation ?? !1,
        stale: b.stale
      }
    }),
    filter: V,
    target: d
  }), c({
    clock: I.fail,
    source: V,
    filter: (p, { error: b }) => p && !b.stopErrorPropagation,
    fn: (p, { error: b, params: j }) => ({
      error: b.error,
      params: j.params,
      meta: { stopErrorPropagation: b.stopErrorPropagation, stale: !1 }
    }),
    target: z
  });
  const { validDataRecieved: he, __: ye } = J(
    c({
      clock: d.done,
      source: {
        partialValidator: D({
          field: s ?? Dt
        })
      },
      fn: ({ partialValidator: p }, {
        params: {
          /* Extract original params, it is params of params */
          params: b,
          meta: j
        },
        result: K
      }) => ({
        result: K,
        params: b,
        validation: p({
          result: K,
          params: b
        }),
        meta: j
      })
    }),
    {
      validDataRecieved: ({ validation: p }) => Tt(p)
    }
  );
  c({
    clock: he,
    source: {
      partialMapper: D({
        field: i
      })
    },
    fn: ({ partialMapper: p }, { params: b, result: j, meta: K }) => ({
      result: p({ params: b, result: j }),
      params: b,
      meta: K
    }),
    target: A.success
  }), c({
    clock: A.success,
    filter: ({ meta: p }) => p.stale,
    fn: ({ params: p, meta: b }) => ({ params: p, meta: b, skipStale: !0 }),
    target: I
  }), c({
    clock: he,
    filter: ({ meta: p }) => !p.stale,
    target: q
  }), c({
    clock: d.fail,
    filter: ({ params: p }) => !p.meta.stopErrorPropagation,
    fn: ({ error: p, params: b }) => ({
      error: p,
      // Extract original params, it is params of params
      params: b.params,
      meta: b.meta
    }),
    target: z
  }), c({
    clock: d.fail,
    fn: ({ error: p, params: b }) => ({
      error: p,
      // Extract original params, it is params of params
      params: b.params,
      meta: b.meta
    }),
    target: U
  }), c({
    clock: ye,
    filter: ({ meta: p }) => !p.stopErrorPropagation,
    fn: ({ params: p, validation: b, meta: j, result: K }) => ({
      params: p,
      error: ee({
        validationErrors: we(b),
        response: K
      }),
      meta: j
    }),
    target: z
  }), c({
    clock: ye,
    fn: ({ params: p, validation: b, meta: j, result: K }) => ({
      params: p,
      error: ee({
        validationErrors: we(b),
        response: K
      }),
      meta: j
    }),
    target: U
  }), c({
    clock: V.updates,
    source: M,
    filter: B(V),
    fn: (p) => ({
      params: p,
      meta: {
        stopErrorPropagation: !1,
        stale: !0
      }
    }),
    target: A.skip
  }), c({
    clock: A.success,
    fn: ({ params: p, result: b, meta: j }) => ({
      status: "done",
      params: p,
      result: b,
      meta: j
    }),
    target: A.finally
  }), c({
    clock: A.failure,
    fn: ({ params: p, error: b, meta: j }) => ({
      status: "fail",
      params: p,
      error: b,
      meta: j
    }),
    target: A.finally
  }), c({
    clock: A.skip,
    fn: ({ params: p, meta: b }) => ({
      status: "skip",
      params: p,
      meta: b
    }),
    target: A.finally
  });
  const ge = {
    start: M,
    finished: A,
    started: S,
    aborted: H,
    reset: v,
    $status: L,
    $idle: st,
    $pending: ot,
    $failed: ct,
    $succeeded: it,
    $finished: lt,
    $enabled: V,
    __: {
      executeFx: h,
      meta: { ...t, name: m, flags: {} },
      kind: r,
      $latestParams: E(me),
      lowLevelAPI: {
        dataSources: F,
        dataSourceRetrieverFx: I,
        sourced: l ?? [],
        paramsAreMeaningless: g ?? !1,
        revalidate: y,
        pushError: $,
        pushData: u,
        startWithMeta: f,
        callObjectCreated: w,
        failedIgnoreSuppression: U
      }
    }
  };
  return He(ge, { clock: v }), ge;
}
function Ht(e) {
  const t = k({
    handler: async ({ params: a, skipStale: o }) => {
      for (const s of e)
        try {
          const i = await s.get({ params: a });
          if (o && (i != null && i.stale))
            continue;
          if (i)
            return i;
        } catch (i) {
          throw {
            stopErrorPropagation: !1,
            error: i
          };
        }
      throw {
        stopErrorPropagation: !1,
        error: new Error("No data source returned data")
      };
    }
  }), r = k({
    handler: async ({ params: a, result: o }) => {
      await Promise.all(
        e.map(Q("set")).filter(Boolean).map((s) => s({ params: a, result: o }))
      );
    }
  }), n = k({
    handler: async ({ params: a }) => {
      await Promise.all(
        e.map(Q("unset")).filter(Boolean).map((o) => o({ params: a }))
      );
    }
  });
  return {
    retrieveDataFx: t,
    notifyAboutNewValidDataFx: r,
    notifyAboutDataInvalidationFx: n
  };
}
const Qe = Symbol("Query");
function Je(e) {
  var t;
  return ((t = e == null ? void 0 : e.__) == null ? void 0 : t.kind) === Qe;
}
const Vt = Symbol("Farfetched node meta"), Kt = Symbol("Farfetched links meta");
function Qt(e, t) {
  return Pe({
    meta: { [Vt]: e, [Kt]: t },
    regional: !0
  });
}
function ue(e) {
  const {
    initialData: t,
    contract: r,
    mapData: n,
    enabled: a,
    validate: o,
    name: s,
    serialize: i,
    sourced: l,
    paramsAreMeaningless: g
  } = e, y = t ?? null, u = Ke({
    name: s ?? De(),
    kind: Qe,
    serialize: ne(i),
    enabled: a,
    meta: {
      serialize: i,
      initialData: y,
      sid: Jt(x(null, { sid: "dummy" }))
    },
    contract: r,
    validate: o,
    mapData: n,
    sourced: l,
    paramsAreMeaningless: g
  }), $ = _(), f = x(y, {
    sid: `ff.${u.__.meta.name}.$data`,
    name: `${u.__.meta.name}.$data`,
    serialize: i,
    skipVoid: !1
  }), d = x(null, {
    sid: `ff.${u.__.meta.name}.$error`,
    name: `${u.__.meta.name}.$error`,
    serialize: ne(i),
    skipVoid: !1
  }), m = x(!0, {
    sid: `ff.${u.__.meta.name}.$stale`,
    name: `${u.__.meta.name}.$stale`,
    serialize: ne(i),
    skipVoid: !1
  });
  c({
    clock: u.finished.success,
    fn: () => null,
    target: d
  }), c({
    clock: u.finished.success,
    fn: ({ result: v }) => v,
    target: f
  }), f.reset(u.finished.failure), c({
    clock: u.finished.failure,
    fn: ({ error: v }) => v,
    target: d
  }), c({
    clock: u.finished.finally,
    fn: ({ meta: v }) => v.stale,
    target: m
  }), c({
    clock: u.__.lowLevelAPI.pushData,
    target: [f, d.reinit]
  }), c({
    clock: u.__.lowLevelAPI.pushError,
    target: [d, f.reinit]
  });
  const h = Te({
    clock: $,
    until: u.$enabled
  }), w = _(), { haveToStart: P, __: F } = J(
    c({
      clock: h,
      source: { stale: m, latestParams: u.__.$latestParams },
      fn: ({ stale: v, latestParams: S }, A) => ({
        haveToStart: v || !Z(A, S),
        params: A
      })
    }),
    {
      haveToStart: ({ haveToStart: v }) => v
    }
  );
  c({
    clock: F,
    fn: () => null,
    target: w
  }), c({
    clock: P,
    fn: ({ params: v }) => v,
    target: u.start
  }), c({
    clock: u.reset,
    target: [f.reinit, d.reinit, m.reinit]
  });
  const I = {
    data: f,
    error: d,
    stale: m,
    pending: u.$pending,
    start: u.start
  }, q = () => I, C = ({
    source: v,
    mapParams: S
  }) => {
    const A = ue(e);
    return A.__.lowLevelAPI.dataSourceRetrieverFx.use(
      T({
        source: v,
        mapParams: ({ params: z, ...U }, H) => ({
          params: S ? S(z, H) : z,
          ...U
        }),
        effect: u.__.lowLevelAPI.dataSourceRetrieverFx
      })
    ), A;
  }, M = Qt(
    { type: "query", name: e.name },
    { $status: u.$status, $data: f, $error: d }
  );
  return ft(M, () => ({
    refresh: $,
    start: u.start,
    reset: u.reset,
    started: E(u.started),
    $data: E(f),
    $error: E(d),
    $status: E(u.$status),
    $idle: E(u.$idle),
    $pending: E(u.$pending),
    $succeeded: E(u.$succeeded),
    $failed: E(u.$failed),
    $finished: E(u.$finished),
    $enabled: E(u.$enabled),
    $stale: m,
    aborted: E(u.aborted),
    finished: {
      success: E(u.finished.success),
      failure: E(u.finished.failure),
      finally: E(u.finished.finally),
      skip: E(u.finished.skip)
    },
    __: {
      ...u.__,
      lowLevelAPI: { ...u.__.lowLevelAPI, refreshSkipDueToFreshness: w },
      experimentalAPI: { attach: C }
    },
    "@@unitShape": q
  }));
}
function Jt(e) {
  const t = e.sid;
  return t != null && t.includes("|") ? t : null;
}
function We(e) {
  const t = e;
  if (N.effect(t.effect))
    return t.effect;
  if (typeof t.handler == "function")
    return k(t.handler);
  throw new Wt(
    "handler or effect must be passed to the config"
  );
}
class Wt extends Error {
  constructor(t) {
    super(t);
  }
}
function Ir(e) {
  const t = ue({
    initialData: e.initialData ?? null,
    contract: e.contract ?? re,
    mapData: e.mapData ?? (({ result: r }) => r),
    enabled: e.enabled,
    validate: e.validate,
    name: e.name,
    serialize: e.serialize
  });
  return t.__.executeFx.use(We(e)), t;
}
function Tr(e) {
  const { source: t, target: r } = e, n = Je(t), a = Array.isArray(r) ? r : [r], o = n ? [t] : Object.values(t), s = e == null ? void 0 : e.fn, i = e == null ? void 0 : e.filter, l = se(o.map((f) => f.start)), g = se(
    o.map((f) => f.finished.success)
  ), y = ce({
    stores: o.map((f) => f.$data),
    predicate: (f) => f !== null
  }), u = n ? t.$data : R(_e(t, (f) => f.$data)), $ = x(null, {
    serialize: "ignore",
    name: "ff.$allParentParamsDictionary",
    sid: "ff.$allParentParamsDictionary",
    skipVoid: !1
  });
  if (n)
    c({
      clock: t.finished.success,
      fn: ({ params: f }) => f,
      target: $
    });
  else
    for (const [f, d] of Object.entries(
      _e(t, (m) => m.finished.success)
    ))
      c({
        clock: d,
        source: $,
        fn: (m, { params: h }) => ({
          ...m,
          [f]: h
        }),
        target: $
      });
  c({
    clock: l,
    fn() {
      return !0;
    },
    target: a.map((f) => f.$stale)
  }), c({
    clock: Te({
      clock: g,
      until: y
    }),
    source: {
      data: u,
      params: $
    },
    filter({ data: f, params: d }) {
      return (i == null ? void 0 : i(
        n ? { result: f, params: d } : ke({ result: f, params: d })
      )) ?? !0;
    },
    fn({ data: f, params: d }) {
      const m = s == null ? void 0 : s(
        n ? { result: f, params: d } : ke({ result: f, params: d })
      );
      return m == null ? void 0 : m.params;
    },
    target: a.map((f) => f.start)
  });
}
function Ge(...e) {
  const t = {};
  for (const r of e)
    if (typeof r == "object")
      for (const [n, a] of Object.entries(r || {})) {
        const o = fe(a);
        o !== null && (t[n] ? t[n] = [t[n], o].flat() : t[n] = o);
      }
  return t;
}
function Gt(...e) {
  const t = [];
  for (const r of e) {
    if (!r)
      continue;
    let n;
    typeof r != "string" ? n = Ye(r).toString() : n = r, t.push(n);
  }
  return t.join("&");
}
function Yt(e) {
  const t = new Headers();
  for (const [r, n] of Object.entries(e)) {
    const a = fe(n);
    if (Array.isArray(a))
      for (const o of a)
        t.append(r, o);
    else
      a !== null && t.append(r, a);
  }
  return t;
}
function Xt(e, t) {
  let r;
  e.startsWith("/") && (r = window.location.origin);
  let n, a;
  typeof t == "string" ? a = t : a = Ye(t).toString(), a ? n = `${e}?${a}` : n = e;
  try {
    return new URL(n, r);
  } catch {
    throw oe({
      reason: "Invalid URL",
      validationErrors: [`"${n}" is not valid URL`]
    });
  }
}
function Ye(e) {
  const t = new URLSearchParams();
  for (const [r, n] of Object.entries(e)) {
    const a = fe(n);
    if (Array.isArray(a))
      for (const o of a)
        t.append(r, o);
    else
      a !== null && t.append(r, a);
  }
  return t;
}
function fe(e) {
  return typeof e == "number" || typeof e == "boolean" ? e.toString() : e ?? null;
}
const Zt = k({
  sid: "ff.fetchFx",
  handler: globalThis.fetch
}), er = k({
  handler: async (e) => {
    const t = await Zt(e).catch((r) => {
      throw Ft({
        reason: (r == null ? void 0 : r.message) ?? null,
        cause: r
      });
    });
    if (!t.ok)
      throw Ce({
        status: t.status,
        statusText: t.statusText,
        response: await t.text().catch(() => null) ?? null
      });
    return t;
  },
  sid: "ff.requestFx"
});
function tr(e) {
  const t = k(e.response.extract), r = k(
    async ({
      url: n,
      method: a,
      query: o,
      headers: s,
      credentials: i,
      body: l,
      abortController: g
    }) => {
      const y = l ? e.request.mapBody(l) : null, u = new Request(Xt(n, o), {
        method: a,
        headers: Yt(s),
        credentials: i,
        body: y,
        signal: g == null ? void 0 : g.signal
      }), $ = await er(u).catch((m) => {
        throw e.response.transformError ? e.response.transformError(m) : m;
      }), f = $.clone(), d = await t($).catch(async (m) => {
        throw St({
          response: await f.text(),
          reason: (m == null ? void 0 : m.message) ?? null
        });
      });
      if (e.response.status) {
        const m = Array.isArray(e.response.status.expected) ? e.response.status.expected : [e.response.status.expected];
        if (!m.includes($.status))
          throw ee({
            validationErrors: [
              `Expected response status has to be one of [${m.join(
                ", "
              )}], got ${$.status}`
            ],
            response: d
          });
      }
      return d;
    }
  );
  return T({
    source: {
      url: O(e.request.url),
      method: O(e.request.method),
      query: O(e.request.query),
      headers: O(e.request.headers),
      credentials: O(e.request.credentials),
      body: O(e.request.body)
    },
    mapParams(n, a) {
      const o = a.url ?? // @ts-expect-error TS cannot infer type correctly, but there is always field in staticConfig or dynamicConfig
      n.url, s = a.credentials ?? // @ts-expect-error TS cannot infer type correctly, but there is always field in staticConfig or dynamicConfig
      n.credentials, i = a.body ?? // @ts-expect-error TS cannot infer type correctly, but there is always field in staticConfig or dynamicConfig
      n.body, l = Gt(a.query, n.query), g = Ge(a.headers, n.headers), { method: y } = a, { abortController: u } = n;
      return {
        url: o,
        method: y,
        // TODO: fix type inference here
        query: l,
        headers: g,
        credentials: s,
        body: i,
        abortController: u
      };
    },
    effect: r
  });
}
function Xe(e) {
  var n;
  const t = R(
    {
      method: O(e.request.method),
      headers: O(e.request.headers)
    },
    ({ method: a, headers: o }) => (
      // reversed merge order to allow any modifications in the user code
      Ge(
        {
          Accept: "application/json",
          "Content-Type": ["GET", "HEAD"].includes(a) ? void 0 : "application/json"
        },
        o
      )
    )
  );
  return tr({
    ...e,
    request: {
      ...e.request,
      headers: t,
      // Serialize body to JSON-string
      mapBody: (a) => JSON.stringify(a)
    },
    response: {
      extract: async (a) => await rr(a) ? null : a.json(),
      transformError: (a) => {
        if (!Me({ error: a }))
          return a;
        const o = a;
        if (typeof o.response != "string")
          return o;
        try {
          const s = JSON.parse(o.response);
          return Ce({
            status: o.status,
            statusText: o.statusText,
            response: s
          });
        } catch {
          return o;
        }
      },
      status: (n = e.response) == null ? void 0 : n.status
    }
  });
}
async function rr(e) {
  return !e.body || e.headers.get("Content-Length") === "0" || (await e.clone().text()).length === 0;
}
function Dr(e) {
  const t = e.request.credentials, r = Xe({
    request: {
      method: e.request.method,
      credentials: t
    }
  }), n = ue({
    initialData: e.initialData,
    contract: e.response.contract ?? re,
    mapData: e.response.mapData ?? (({ result: s }) => s),
    validate: e.response.validate,
    enabled: e.enabled,
    name: e.name,
    serialize: e.serialize,
    sourced: [
      e.request.url,
      e.request.body,
      e.request.headers,
      e.request.query
    ],
    paramsAreMeaningless: !0
  }), a = k((s) => {
    const i = new AbortController();
    return Be(() => i.abort()), r({ ...s, abortController: i });
  });
  n.__.executeFx.use(
    T({
      source: {
        partialUrl: D({
          field: e.request.url
        }),
        partialBody: D({
          field: e.request.body
        }),
        partialHeaders: D({
          field: e.request.headers
        }),
        partialQuery: D({
          field: e.request.query
        })
      },
      mapParams(s, { partialUrl: i, partialBody: l, partialHeaders: g, partialQuery: y }) {
        return {
          url: i(s),
          body: l(s),
          headers: g(s),
          query: y(s)
        };
      },
      effect: a
    })
  );
  const o = {
    ...n,
    __: { ...n.__, executeFx: a }
  };
  return e.concurrency && (o.__.meta.flags.concurrencyFieldUsed = !0), setTimeout(() => {
    var s, i;
    o.__.meta.flags.concurrencyOperatorUsed || Ue(o, {
      strategy: ((s = e.concurrency) == null ? void 0 : s.strategy) ?? "TAKE_LATEST",
      abortAll: (i = e.concurrency) == null ? void 0 : i.abort
    });
  }), o;
}
const Ze = Symbol("Mutation");
function nr(e) {
  var t;
  return ((t = e == null ? void 0 : e.__) == null ? void 0 : t.kind) === Ze;
}
function de(e) {
  const { name: t, enabled: r, contract: n, validate: a, mapData: o } = e, s = Ke({
    name: t ?? De(),
    serialize: "ignore",
    enabled: r,
    kind: Ze,
    meta: null,
    contract: n,
    validate: a,
    mapData: o
  }), i = {
    pending: s.$pending,
    start: s.start,
    reset: s.reset
  }, l = () => i, g = ({
    source: y,
    mapParams: u
  }) => {
    const $ = de(e);
    return $.__.lowLevelAPI.dataSourceRetrieverFx.use(
      T({
        source: y,
        mapParams: ({ params: f, ...d }, m) => ({
          params: u ? u(f, m) : f,
          ...d
        }),
        effect: s.__.lowLevelAPI.dataSourceRetrieverFx
      })
    ), $;
  };
  return {
    start: s.start,
    reset: s.reset,
    started: E(s.started),
    aborted: E(s.aborted),
    $status: E(s.$status),
    $idle: E(s.$idle),
    $pending: E(s.$pending),
    $succeeded: E(s.$succeeded),
    $failed: E(s.$failed),
    $finished: E(s.$finished),
    $enabled: E(s.$enabled),
    finished: {
      success: E(s.finished.success),
      failure: E(s.finished.failure),
      finally: E(s.finished.finally),
      skip: E(s.finished.skip)
    },
    __: { ...s.__, experimentalAPI: { attach: g } },
    "@@unitShape": l
  };
}
function jr(e) {
  const t = de({
    name: e.name,
    enabled: e.enabled,
    contract: e.contract ?? re,
    mapData: ({ result: r }) => r
  });
  return t.__.executeFx.use(We(e)), t;
}
function Or(e) {
  const t = e.request.credentials, r = Xe({
    request: { method: e.request.method, credentials: t },
    response: { status: e.response.status }
  }), n = de({
    contract: e.response.contract ?? re,
    mapData: e.response.mapData ?? (({ result: s }) => s),
    validate: e.response.validate,
    enabled: e.enabled,
    name: e.name
  }), a = k((s) => {
    const i = new AbortController();
    return Be(() => i.abort()), r({ ...s, abortController: i });
  });
  n.__.executeFx.use(
    T({
      source: {
        partialUrl: D({
          field: e.request.url
        }),
        partialBody: D({
          field: e.request.body
        }),
        partialHeaders: D({
          field: e.request.headers
        }),
        partialQuery: D({
          field: e.request.query
        })
      },
      mapParams(s, { partialUrl: i, partialBody: l, partialHeaders: g, partialQuery: y }) {
        return {
          url: i(s),
          body: l(s),
          headers: g(s),
          query: y(s)
        };
      },
      effect: a
    })
  );
  const o = {
    ...n,
    __: { ...n.__, executeFx: a }
  };
  return e.concurrency && (o.__.meta.flags.concurrencyFieldUsed = !0), e.concurrency && setTimeout(() => {
    var s, i;
    o.__.meta.flags.concurrencyOperatorUsed || Ue(o, {
      strategy: ((s = e.concurrency) == null ? void 0 : s.strategy) ?? "TAKE_EVERY",
      abortAll: (i = e.concurrency) == null ? void 0 : i.abort
    });
  }), o;
}
const ar = [
  "ms",
  "milli",
  "millisecond",
  "milliseconds"
], sr = ["s", "sec", "secs", "second", "seconds"], or = ["m", "min", "mins", "minute", "minutes"], cr = ["h", "hr", "hrs", "hour", "hours"];
function W(e) {
  if (typeof e == "number")
    return e;
  let t = 0;
  for (const r of e.split(" "))
    switch (!0) {
      case Y(r, ar):
        t += X(r);
        break;
      case Y(r, sr):
        t += X(r) * 1e3;
        break;
      case Y(r, or):
        t += X(r) * 6e4;
        break;
      case Y(r, cr):
        t += X(r) * 36e5;
        break;
    }
  return t;
}
function Y(e, t) {
  return t.includes(ir(e));
}
function ir(e) {
  return e.replace(/[0-9.]/g, "");
}
function X(e) {
  return e.includes(".") ? parseFloat(e) : parseInt(e);
}
function Rr(e, {
  times: t,
  delay: r,
  filter: n,
  mapParams: a,
  ...o
}) {
  const s = o.supressIntermediateErrors ?? !0, i = O(t), l = x(1, {
    serialize: "ignore",
    name: "ff.$attempt",
    sid: "ff.$attempt"
  }), g = R({
    attempt: l
  }), y = R(
    l,
    i,
    (h, w) => s && h <= w
  ), u = _(), $ = _(), f = D({
    field: n ?? !0
  }), { planNextAttempt: d, __: m } = J(
    c({
      clock: u,
      source: {
        maxAttempts: i,
        attempt: l,
        partialFilter: f
      },
      filter: ({ partialFilter: h }, w) => h(w),
      fn: ({ attempt: h, maxAttempts: w }, { params: P, error: F, meta: I }) => ({
        params: P,
        error: F,
        meta: { ...I, attempt: h, maxAttempts: w }
      })
    }),
    { planNextAttempt: ({ meta: h }) => h.attempt <= h.maxAttempts }
  );
  if (c({
    clock: Fe({
      clock: c({
        clock: d,
        source: {
          partialMapper: D({
            field: a ?? (({ params: h }) => h)
          })
        },
        fn: ({ partialMapper: h }, w) => h(w)
      }),
      timeout: R(
        {
          partialTimeout: D({
            field: r
          }),
          meta: g
        },
        ({ partialTimeout: h, meta: w }) => W(h(w))
      )
    }),
    fn: (h) => ({
      params: h,
      meta: { stopErrorPropagation: !1, stale: !0 }
    }),
    target: [$, e.__.lowLevelAPI.startWithMeta]
  }), l.on($, (h) => h + 1).reset([e.finished.success, e.start]), o.otherwise && c({ clock: m, target: o.otherwise }), s) {
    const h = e.__.lowLevelAPI.dataSourceRetrieverFx.use.getCurrent();
    c({
      clock: e.__.lowLevelAPI.failedIgnoreSuppression,
      target: u
    }), e.__.lowLevelAPI.dataSourceRetrieverFx.use(
      T({
        source: { supressError: y, partialFilter: f },
        mapParams: (w, { supressError: P, partialFilter: F }) => ({
          ...w,
          supressError: P,
          partialFilter: F
        }),
        effect: k(async ({ supressError: w, partialFilter: P, ...F }) => {
          const I = Se(u, { safe: !0 });
          try {
            return { ...await h(F), stopErrorPropagation: w };
          } catch (q) {
            const C = {
              params: F.params,
              error: q.error,
              meta: F.meta
            };
            throw (
              /*
               * If filter returns false, this fail is not supposed to be retried
               * so we should not suppress this error in any case.
               *
               * If filter returns is true, we should suppress this error only if
               * supressError is true.
               */
              P(C) && w ? (I(C), { error: q.error, stopErrorPropagation: !0 }) : q
            );
          }
        })
      })
    );
  }
  c({ clock: e.finished.failure, target: u });
}
const et = {
  randomize: { spread: 0 }
};
function Nr(e, t = et) {
  return function({ attempt: r }) {
    return e * r + tt(t);
  };
}
function qr(e, t = et) {
  return function({ attempt: r }) {
    return e ** r + tt(t);
  };
}
function tt({ randomize: e }) {
  const { spread: t } = e;
  return $t({ min: -t, max: t });
}
function Lr(e, t) {
  const r = T({
    source: O(t.after).map(W),
    effect(n, a) {
      return new Promise((o) => {
        var l;
        const s = setTimeout(() => {
          a.abort(Pt({ timeout: n })), o();
        }, n), i = () => {
          clearTimeout(s), o();
        };
        (l = a.promise) == null || l.then(i, i);
      });
    }
  });
  c({
    clock: e.__.lowLevelAPI.callObjectCreated,
    target: r
  });
}
function zr(e, {
  on: t,
  by: r
}) {
  const n = lr(e), a = _(), o = _();
  J({
    source: c({
      clock: t.finished.success,
      source: {
        partialRule: D({
          field: r.success
        }),
        queryState: n
      },
      fn: ({ partialRule: l, queryState: g }, y) => l({
        query: g,
        mutation: y
      })
    }),
    match: {
      fillData: (l) => ve(l.result)
    },
    cases: { fillData: a, __: o }
  }), r.failure && J({
    source: c({
      clock: t.finished.failure,
      source: {
        partialRule: D({
          field: r.failure
        }),
        queryState: n
      },
      fn: ({ partialRule: l, queryState: g }, y) => l({
        query: g,
        mutation: y
      })
    }),
    match: {
      fillData: (l) => ve(l.result)
    },
    cases: { fillData: a, __: o }
  }), c({
    clock: a,
    fn: ({ result: l }) => l,
    target: e.__.lowLevelAPI.pushData
  }), c({
    clock: o,
    fn: ({ error: l }) => l,
    target: e.__.lowLevelAPI.pushError
  });
  const { shouldRefetch: s, __: i } = J(
    se([a, o]).map(({ refetch: l }) => l),
    {
      shouldRefetch: (l) => !!l
    }
  );
  c({
    clock: s,
    source: n,
    filter: (l, g) => typeof g == "object" && "params" in g || l && "params" in l,
    fn: (l, g) => typeof g == "object" && "params" in g ? { params: g.params, refresh: !0 } : { params: l == null ? void 0 : l.params, refresh: !0 },
    target: [e.__.lowLevelAPI.revalidate, e.$stale.reinit]
  }), c({
    clock: i,
    source: n,
    filter: (l) => l && "params" in l,
    fn: (l) => ({
      params: l.params,
      refresh: !1
    }),
    target: e.__.lowLevelAPI.revalidate
  });
}
function lr(e) {
  return R(
    {
      idle: e.$idle,
      result: e.$data,
      params: e.__.$latestParams,
      error: e.$error,
      failed: e.$failed
    },
    ({ idle: t, result: r, params: n, error: a, failed: o }) => r == null && a == null ? null : t ? { result: r } : o ? { error: a, params: n } : { result: r, params: n }
  );
}
function Cr(e, t) {
  var a;
  const { source: r, mapParams: n } = t ?? {};
  return (a = e.__.experimentalAPI) == null ? void 0 : a.attach({
    source: r ?? x(null, {
      serialize: "ignore"
    }),
    mapParams: n ?? ((o) => o)
  });
}
function pe(e) {
  const t = x(e, {
    serialize: "ignore",
    name: "ff.$cacheInstance",
    sid: "ff.$cacheInstance"
  });
  return { ...e, __: { $instance: t } };
}
function rt({
  adapter: e,
  options: t,
  events: r
}) {
  t != null && t.hit && c({
    clock: e.get.done,
    filter: ({ result: n }) => n !== null,
    fn: ({ params: n }) => ({ key: n.key }),
    target: t.hit
  }), t != null && t.miss && c({
    clock: e.get.done,
    filter: ({ result: n }) => n === null,
    fn: ({ params: n }) => ({ key: n.key }),
    target: t.miss
  }), t != null && t.expired && (r != null && r.itemExpired) && c({
    clock: r.itemExpired,
    fn: ({ key: n }) => ({ key: n }),
    target: t.expired
  }), t != null && t.evicted && (r != null && r.itemEvicted) && c({
    clock: r.itemEvicted,
    target: t.evicted
  });
}
function ur(e) {
  const { maxEntries: t, maxAge: r, observability: n } = e ?? {};
  let a = {};
  const o = _(), s = _(), i = _(), l = _(), g = _();
  g.watch(() => {
    a = {};
  });
  const y = yt({ clock: o }), u = c({
    clock: o,
    source: { now: y },
    fn: ({ now: f }, { key: d, value: m }) => fr(
      a,
      { key: d, entry: { value: m, cachedAt: f } },
      t
    )
  });
  if (u.watch(({ next: f }) => {
    a = f;
  }), c({
    clock: u,
    filter: ({ evicted: f }) => !!f,
    fn: ({ evicted: f }) => ({ key: f }),
    target: l
  }), s.watch(({ key: f }) => {
    const { [f]: d, ...m } = a;
    a = m;
  }), r) {
    const f = W(r);
    o.watch((d) => {
      const m = Se(i, { safe: !0 });
      setTimeout(() => m(d), f);
    }), c({
      clock: i,
      fn: ({ key: d }) => ({ key: d }),
      target: s
    });
  }
  const $ = {
    get: k(({ key: f }) => {
      const d = a[f] ?? null;
      if (!d)
        return null;
      if (r) {
        const m = (d == null ? void 0 : d.cachedAt) + W(r);
        if (Date.now() >= m)
          return s({ key: f }), null;
      }
      return d;
    }),
    set: k(o),
    unset: k(s),
    purge: g
  };
  return rt({
    adapter: $,
    options: n,
    events: { itemExpired: i, itemEvicted: l }
  }), pe($);
}
function fr(e, { key: t, entry: r }, n) {
  if (n === void 0)
    return { next: { ...e, [t]: r }, evicted: null };
  const a = Object.keys(e);
  if (a.length < n)
    return { next: { ...e, [t]: r }, evicted: null };
  const [o] = a, { [o]: s, ...i } = e;
  return { next: { ...i, [t]: r }, evicted: o };
}
function dr(e) {
  let t = 0, r = 0;
  for (; r < e.length; )
    t = (t << 5) - t + e.charCodeAt(r++) | 0;
  return t.toString(36);
}
function nt(e) {
  const t = /* @__PURE__ */ new Set();
  function r(n) {
    if (n === void 0)
      return;
    if (n === null)
      return "null";
    if (typeof n == "number")
      return isFinite(n) ? `${n}` : "null";
    if (typeof n == "function")
      throw new TypeError("Can't serialize function");
    if (typeof n != "object")
      return JSON.stringify(n);
    if (t.has(n))
      throw new TypeError("Can't serialize cyclic structure");
    if (t.add(n), Array.isArray(n)) {
      const o = n.map((s) => r(s) || "null").join(",");
      return t.delete(n), `[${o}]`;
    }
    const a = Object.keys(n).sort().map((o) => {
      const s = r(n[o]);
      return s ? `${r(o)}:${s}` : "";
    }).filter(Boolean).join(",");
    return t.delete(n), `{${a}}`;
  }
  return r(e);
}
function pr({
  sid: e,
  params: t = null,
  sources: r
}) {
  try {
    return nt({ params: t, sources: r, sid: e }) ?? null;
  } catch {
    return null;
  }
}
function mr({
  sid: e,
  params: t = null,
  sources: r
}) {
  try {
    const n = nt({ params: t, sources: r, sid: e });
    return dr(n);
  } catch {
    return null;
  }
}
function hr(e) {
  const t = yr(e);
  if (t)
    return t;
  const r = gr(e);
  if (r)
    return r;
  throw new Error(
    "Query does not have sid or uniq name, which is required for caching, read more https://effector.dev/en/explanation/sids/"
  );
}
function yr(e) {
  return e.__.meta.sid ?? null;
}
const xe = /* @__PURE__ */ new Set();
function gr(e) {
  const t = e.__.meta.name;
  return xe.has(t) ? null : (xe.add(t), t);
}
function Mr(e, t) {
  const {
    adapter: r,
    staleAfter: n,
    purge: a,
    humanReadableKeys: o
  } = {
    adapter: (t == null ? void 0 : t.adapter) ?? ur(),
    humanReadableKeys: !1,
    ...t
  }, s = o ? pr : mr, i = hr(e), l = e.__.lowLevelAPI.sourced.map(pt), g = k(async (d) => Promise.all(l.map((m) => m(d)))), y = k(async ({ instance: d, params: m }) => {
    const h = await g(m), w = s({
      sid: i,
      params: e.__.lowLevelAPI.paramsAreMeaningless ? null : m,
      sources: h
    });
    w && await d.unset({ key: w });
  }), u = k(async ({ instance: d, params: m, result: h }) => {
    const w = await g(m), P = s({
      sid: i,
      params: e.__.lowLevelAPI.paramsAreMeaningless ? null : m,
      sources: w
    });
    P && await d.set({ key: P, value: h });
  }), $ = k(async ({ params: d, instance: m }) => {
    const h = await g(d), w = s({
      sid: i,
      params: e.__.lowLevelAPI.paramsAreMeaningless ? null : d,
      sources: h
    });
    if (!w)
      return null;
    const P = await m.get({ key: w });
    if (!P)
      return null;
    const F = n ? P.cachedAt + W(n) <= Date.now() : !0;
    return { result: P.value, stale: F };
  }), f = {
    name: "cache",
    get: T({
      source: {
        instance: r.__.$instance
      },
      mapParams: ({ params: d }, { instance: m }) => ({
        params: d,
        instance: m
      }),
      effect: $
    }),
    set: T({
      source: {
        instance: r.__.$instance
      },
      mapParams: ({ params: d, result: m }, { instance: h }) => ({
        params: d,
        result: m,
        instance: h
      }),
      effect: u
    }),
    unset: T({
      source: {
        instance: r.__.$instance
      },
      mapParams: ({ params: d }, { instance: m }) => ({
        instance: m,
        params: d
      }),
      effect: y
    })
  };
  e.__.lowLevelAPI.dataSources.unshift(f), a && c({
    clock: a,
    source: { instance: r.__.$instance },
    target: k(
      ({ instance: d }) => d.purge()
    )
  });
}
const ae = "__farfetched_meta__";
function at(e) {
  const { storage: t, observability: r, maxAge: n, maxEntries: a, serialize: o } = e;
  function s() {
    const h = k(async (v) => {
      const S = await d(v);
      if (!S)
        return null;
      try {
        const A = JSON.parse(S);
        return {
          ...A,
          value: o != null && o.read ? o.read(A.value) : A.value
        };
      } catch {
        return null;
      }
    }), w = k(
      async ({ key: v, value: S }) => {
        const A = JSON.stringify({
          value: o != null && o.write ? o.write(S) : S,
          timestamp: Date.now()
        });
        $.addKey({ key: v }), await f({ key: v, value: A });
      }
    ), P = k(async (v) => {
      $.removeKey({ key: v }), await m(v);
    }), F = _(), I = _(), q = _(), C = k(
      async (v) => Promise.all(v.map(P))
    );
    c({
      clock: q,
      source: $.$meta,
      fn: (v) => (v == null ? void 0 : v.keys) ?? [],
      target: C
    }), n && c({
      clock: Fe({
        clock: c({
          clock: f.done,
          filter: ({ params: v }) => v.key !== ae
        }),
        timeout: W(n)
      }),
      fn: Q("params"),
      target: [F, P]
    });
    const M = {
      get: k(async ({ key: v }) => {
        const S = await h(v);
        if (!S)
          return null;
        if (n) {
          const A = (S == null ? void 0 : S.timestamp) + W(n);
          if (Date.now() >= A)
            return F({ key: v, value: S.value }), await P(v), null;
        }
        return { value: S.value, cachedAt: S.timestamp };
      }),
      set: k(
        async ({ key: v, value: S }) => {
          var U, H;
          const A = await l(), z = ((U = A == null ? void 0 : A.keys) == null ? void 0 : U.length) ?? 0;
          if (a && z >= a) {
            const L = (H = A == null ? void 0 : A.keys) == null ? void 0 : H.slice(0, z - a + 1);
            for (const G of L ?? [])
              I({ key: G }), await P(G);
          }
          await w({ key: v, value: S });
        }
      ),
      unset: k(async ({ key: v }) => {
        await P(v);
      }),
      purge: q
    };
    return rt({
      adapter: M,
      options: r,
      events: { itemExpired: F, itemEvicted: I }
    }), pe(M);
  }
  const i = x(null, {
    serialize: "ignore",
    name: "ff.browserStorage.$meta",
    sid: "ff.browserStorage.$meta"
  }), l = k(async () => {
    const h = await d(ae);
    if (!h)
      return null;
    try {
      return JSON.parse(h);
    } catch {
      return null;
    }
  }), g = k(
    (h) => f({ key: ae, value: JSON.stringify(h) })
  ), y = _(), u = _(), $ = {
    $meta: i,
    addKey: y,
    removeKey: u
  };
  c({ clock: l.doneData, target: i }), c({ clock: i, filter: Boolean, target: g }), c({
    clock: y,
    source: i,
    fn: (h, { key: w }) => {
      const P = (h == null ? void 0 : h.keys) ?? [];
      return P.includes(w) ? h : { ...h, keys: [...P, w] };
    },
    target: i
  }), c({
    clock: u,
    source: i,
    fn: (h, { key: w }) => {
      var P;
      return {
        ...h,
        keys: ((P = h == null ? void 0 : h.keys) == null ? void 0 : P.filter((F) => F !== w)) ?? []
      };
    },
    target: i
  });
  const f = k((h) => {
    t().setItem(h.key, h.value);
  }), d = k((h) => t().getItem(h)), m = k((h) => t().removeItem(h));
  return s();
}
function Br(e) {
  return at({ storage: () => localStorage, ...e });
}
function Ur(e) {
  return at({
    storage: () => sessionStorage,
    ...e
  });
}
function Hr() {
  return pe({
    get: k(() => null),
    set: k(() => {
    }),
    purge: _(),
    unset: k()
  });
}
function Vr() {
  return _();
}
function Kr(e, t) {
  const r = [], [n, a] = bt(t.triggers ?? [], N.event);
  r.push(...n);
  const o = [e.$enabled];
  t.enabled !== void 0 && o.push(t.enabled);
  const s = ce({
    predicate: Boolean,
    stores: o
  });
  if (a.length > 0) {
    const l = a.map(
      ($) => $["@@trigger"]()
    ), g = x(!1, {
      serialize: "ignore",
      name: "ff.$alreadySetup",
      sid: "ff.$alreadySetup"
    }), { setup: y, teardown: u } = dt(g, {
      setup: () => !0,
      teardown: () => !1
    });
    c({
      clock: [
        e.finished.success,
        c({ clock: s.updates, filter: s })
      ],
      filter: B(g),
      target: [...l.map(Q("setup")), y]
    }), c({
      clock: s.updates,
      filter: Ie(g, B(s)),
      target: [...l.map(Q("teardown")), u]
    }), r.push(...l.map(Q("fired")));
  }
  if (t.automatically) {
    const l = e.finished.finally.map(Q("params")), g = x([], {
      serialize: "ignore",
      name: "ff.$previousSources",
      sid: "ff.$previousSources"
    }), y = R(
      e.__.lowLevelAPI.sourced.map(
        ($) => D({ field: $ })
      )
    );
    c({
      clock: l,
      source: y,
      fn: ($, f) => $.map((d) => d(f)),
      filter: s,
      target: g
    });
    const u = x(null, {
      serialize: "ignore",
      name: "ff.$nextSources",
      sid: "ff.$nextSources"
    });
    c({
      // @ts-expect-error I have no idea
      clock: e.__.lowLevelAPI.sourced.map(mt).filter(N.store),
      source: {
        latestParams: e.__.$latestParams,
        partialSources: y
      },
      filter: B(e.$idle),
      fn: ({ latestParams: $, partialSources: f }) => f.map((d) => d($)),
      target: u
    }), r.push(
      c({
        clock: [u.updates, s.updates.filter({ fn: Boolean })],
        source: [u, g],
        filter: ([$, f]) => !Z($, f)
      })
    );
  }
  const i = c({ clock: r, filter: s });
  c({
    clock: i,
    filter: B(e.$idle),
    fn: () => !0,
    target: e.$stale
  }), c({
    clock: gt(i),
    source: e.__.$latestParams,
    filter: B(e.$idle),
    target: e.refresh
  });
}
function $r(e, { barrier: t }) {
  if (Array.isArray(e))
    for (const r of e)
      $r(r, { barrier: t });
  else {
    c({ clock: e.started, target: t.__.touch }), c({
      clock: e.finished.failure,
      target: t.__.operationFailed
    }), c({
      clock: t.activated,
      filter: e.$failed,
      source: e.__.$latestParams,
      fn: (n) => ({
        params: n,
        meta: { stopErrorPropagation: !1, stale: !1 }
      }),
      target: e.__.lowLevelAPI.startWithMeta
    });
    const r = T({
      source: { mutex: t.__.$mutex, active: t.$active },
      async effect({ mutex: n }) {
        return await (n == null ? void 0 : n.waitForUnlock()), null;
      }
    });
    e.__.lowLevelAPI.dataSources.unshift({
      name: "barrier_blocker",
      get: r
    });
  }
}
function Qr({
  active: e,
  perform: t,
  activateOn: r,
  deactivateOn: n
}) {
  const a = _(), o = _(), s = _(), i = _(), l = _(), g = kr(t ?? []);
  let y;
  if (e)
    y = e;
  else if (N.event(r) && N.event(n))
    y = x(!1, {
      sid: "barrier.$active",
      name: "barrier.$active"
    }).on(r, () => !0).on(n, () => !1);
  else if (r) {
    if (y = x(!1, {
      sid: "barrier.$active",
      name: "barrier.$active"
    }), "failure" in r && r.failure) {
      const $ = r.failure;
      c({
        clock: i,
        filter: ({ error: f, params: d }) => $({ error: f, params: d }),
        fn: () => !0,
        target: [y, s]
      }), c({
        clock: xt({
          events: g.map(Q("end")),
          reset: i
        }),
        fn: () => !1,
        target: y
      });
    }
  } else
    throw new Error("Invalid configuration of createBarrier");
  J({
    clock: [y, s],
    source: y,
    match: { activated: Boolean },
    cases: { activated: a, __: o }
  }), c({
    clock: s,
    filter: y,
    target: _r(g)
  });
  const u = x(null, { serialize: "ignore" });
  return c({
    clock: s,
    source: { mutex: u, active: y },
    filter: ({ mutex: $ }) => $ === null,
    fn: ({ active: $ }) => new At($),
    target: u
  }), c({
    clock: a,
    target: T({
      source: u,
      effect($) {
        $ == null || $.acquire();
      }
    })
  }), c({
    clock: o,
    target: T({
      source: u,
      effect($) {
        $ == null || $.release();
      }
    })
  }), {
    $active: E(y),
    activated: E(a),
    deactivated: E(o),
    __: { touch: s, operationFailed: i, operationDone: l, $mutex: u }
  };
}
function _r(e) {
  const t = _();
  for (const { start: r, $pending: n } of e)
    c({
      clock: t,
      filter: B(n),
      target: r
    });
  return t;
}
function kr(e) {
  return e.map((t) => {
    if (vr(t))
      return {
        start: t.start,
        end: Ee(
          c({
            clock: [t.finished.success, t.finished.skip]
          })
        ),
        $pending: t.$pending
      };
    if (br(t))
      return {
        start: t,
        end: Ee(t.done),
        $pending: t.pending
      };
    {
      const r = x(!1, { serialize: "ignore" }).on(t.start, () => !0).on(t.end, () => !1);
      return { ...t, $pending: r };
    }
  });
}
function vr(e) {
  return Je(e) || nr(e);
}
function br(e) {
  return N.effect(e);
}
function Ee(e) {
  return c({
    clock: e,
    fn: () => {
    }
  });
}
export {
  Kt as NodeLinksSumbol,
  Vt as NodeMetaSumbol,
  ze as abortError,
  $r as applyBarrier,
  Cr as attachOperation,
  Mr as cache,
  Ar as combineSourced,
  Ue as concurrency,
  oe as configurationError,
  Tr as connectQuery,
  Qr as createBarrier,
  pe as createCacheAdapter,
  de as createHeadlessMutation,
  ue as createHeadlessQuery,
  Or as createJsonMutation,
  Dr as createJsonQuery,
  jr as createMutation,
  Ir as createQuery,
  Vr as declareParams,
  qr as exponentialDelay,
  Zt as fetchFx,
  Ce as httpError,
  ur as inMemoryCache,
  ee as invalidDataError,
  Me as isHttpError,
  Sr as isHttpErrorCode,
  xr as isInvalidDataError,
  Fr as isNetworkError,
  Pr as isPreparationError,
  Er as isTimeoutError,
  Kr as keepFresh,
  Nr as linearDelay,
  Br as localStorageCache,
  Ft as networkError,
  D as normalizeSourced,
  Be as onAbort,
  St as preparationError,
  Rr as retry,
  Ur as sessionStorageCache,
  Lr as timeout,
  Pt as timeoutError,
  re as unknownContract,
  zr as update,
  Hr as voidCache
};
